import Joi from "joi";

export const deviceLinkValidator = (data) => {
  const schema = Joi.object({
    _id: Joi.string().required().messages({
      "string.empty": `"Nama perangkat" tidak boleh kosong`,
    }),
    token: Joi.string().required().messages({
      "string.empty": `"Token" tidak boleh kosong`,
    }),
  });
  return schema.validate(data);
};

export const deviceUseValidator = (data) => {
  const schema = Joi.object({
    patient: Joi.string().required().messages({
      "string.empty": `"Pasien" tidak boleh kosong`,
    }),
    patientDetail: Joi.object()
      .required()
      .messages({
        "object.base": `"Pasien ID:${data.patient}" tidak ditemukan`,
      }),
  });
  return schema.validate(data);
};

export const setDeviceWifiValidator = (data) => {
  const schema = Joi.object({
    ssid: Joi.string().required().messages({
      "string.empty": `"Nama Wifi" tidak boleh kosong`,
    }),
    password: Joi.string().required().messages({
      "string.empty": `"Password Wifi" tidak boleh kosong`,
    }),
  });
  return schema.validate(data);
};
